import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from 'sonner';
import Navigation from './components/Navigation';
import EconomicTicker from './components/EconomicTicker';
import Footer from './components/Footer';
import AIAssistant from './components/AIAssistant';
import InstallPWAPrompt from './components/InstallPWAPrompt';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import InvestmentGuide from './pages/InvestmentGuide';
import CompanyFormation from './pages/CompanyFormation';
import VideoPresentations from './pages/VideoPresentations';
import News from './pages/News';
import Contact from './pages/Contact';
import SectorDetail from './pages/SectorDetail';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-background flex flex-col">
          <Navigation />
          <EconomicTicker />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/investment-guide" element={<InvestmentGuide />} />
              <Route path="/company-formation" element={<CompanyFormation />} />
              <Route path="/videos" element={<VideoPresentations />} />
              <Route path="/news" element={<News />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/sectors/:sectorKey" element={<SectorDetail />} />
            </Routes>
          </main>
          <Footer />
          <AIAssistant />
          <InstallPWAPrompt />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
